import React, {useState} from "react";
import {Modal} from "../../../../ui/Modal/Modal";
import {ModalContentProps} from "../ModalContent";
import {IFilter} from "../../../../interface/Basic/window";
import {Select} from "../../../../ui/Select/Select";

export const Citizenship = ({onGoBack, onGoInfoModal, isInfoModalOpen}: ModalContentProps) => {

    const countries: IFilter[] = [
        {id: 1, name: "Россия"},
        {id: 2, name: "Беларусь"},
        {id: 3, name: "Украина"},
        {id: 4, name: "Казахстан"},
    ]

    const [selectedCountry, setSelectedCountry] = useState<IFilter | null>(null)

    const content = () => {
        return <Select
            onClean={() => setSelectedCountry(null)}
            isCleanable={true}
            isSearchable={true}
            data={countries}
            onSelect={(id) => {
                const item = countries.find(i => i.id === id)
                if (item) setSelectedCountry(item)
            }}
            selectedValue={selectedCountry ? selectedCountry.id : null}
        />
    }

    return <Modal
        disable={!selectedCountry}
        title={'Гражданство'}
        onSubmit={() => {
            console.log('submit')
        }}
        content={content}
        onClose={()=>{
            if(isInfoModalOpen){
                onGoInfoModal()
            }
            onGoBack()
        }}/>
}